
import { Inject, Injectable, DOCUMENT } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HtmlEntityDecoderService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  decode(value: unknown): string {
    if (value === null || value === undefined) return '';

    let decoded = String(value);

    // Handles double encoded strings like &amp;amp; -> &amp; -> &
    for (let i = 0; i < 5; i++) {
      const textarea = this.document.createElement('textarea');
      textarea.innerHTML = decoded;

      const next = textarea.value;

      if (next === decoded) break;

      decoded = next;
    }

    return decoded;
  }

  decodeDeep<T>(value: T): T {
    if (typeof value === 'string') {
      return this.decode(value) as T;
    }

    if (Array.isArray(value)) {
      return value.map((item) => this.decodeDeep(item)) as T;
    }

    if (value && typeof value === 'object') {
      return Object.entries(value).reduce((acc, [key, val]) => {
        return {
          ...acc,
          [key]: this.decodeDeep(val),
        };
      }, {} as T);
    }

    return value;
  }
}
